import script from "./SearchTopResponse.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchTopResponse.vue?vue&type=script&lang=ts&setup=true"

import "./SearchTopResponse.vue?vue&type=style&index=0&id=6a46d49e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a46d49e"]])

export default __exports__